export default (refresh) => {
  if (!window.Forepaas.config.server) return
}
